import { ClientError } from 'graphql-request'

/**
 * A lib graphql-request concatena a request e a response dentro de
 * `error.message`, deixando a mensagem ilegível. O erro "correto" fica em
 * `error.response.errors`, sempre como um array (mesmo quando há um único erro).
 */
export const getGraphQLErrorMessage = (error: unknown): string | undefined => {
  const clientError = error as ClientError
  const graphQLErrors = clientError?.response?.errors

  return graphQLErrors?.length ? graphQLErrors[0].message : clientError?.message
}
